import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy route: the standalone link checker (a developer-grade tool with
// raw JSON output) was retired in favour of the unified Scam Checker.
export const Route = createFileRoute('/_auth/tools/link-checker')({
  beforeLoad: () => {
    throw redirect({ to: '/tools', replace: true })
  },
})
